// src/customer-form/CountrySpecificFields.jsx
import { countryTemplates } from './constants';

export default function CountrySpecificFields({ formData, handleChange, handleBlur, errors = {}, touched = {} }) {
  const template = countryTemplates[formData.country];

  if (!template) return (
    <p className="hint">No specific information required for the selected country.</p>
  );

  return (
    <div className="row2">
      {template.fields.map((field) => {
        const value = String(formData[field.name] ?? '');
        return (
          <div className={`field ${touched[field.name] && errors[field.name] ? 'has-error' : ''}`} key={`${formData.country}-${field.name}`}>
            <label className="label">
              {field.label} {field.required && <span className="required">*</span>}
            </label>
            {touched[field.name] && errors[field.name] && <div className="error-message">{errors[field.name]}</div>}
            {field.type === 'select' ? (
              <select className="select" name={field.name} value={value} onChange={handleChange} onBlur={handleBlur} required={field.required}>
                <option value="">{field.selectPlaceholder || 'Select ' + field.label}</option>
                {field.options?.map((option) => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            ) : (
              <input
                className="input"
                name={field.name}
                type={field.inputType || 'text'}
                value={value}
                placeholder={field.placeholder}
                onChange={handleChange}
                onBlur={handleBlur}
                required={field.required}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
